import { cva, cx } from '../../utils/cva';

export const tabsListVariants = cva({
  base: [
    'flex',
    'border-b',
    'border-subtle',
    '[--tabs-padding-x:var(--space-4)]',
    '-mx-0.5',
  ],
  variants: {
    fixed: {
      true: ['gap-0', '[&>*]:flex-auto'],
      false: 'gap-4',
    },
    size: {
      md: [
        'text-sm',
        '[--tabs-padding-y:var(--space-1p5)]',
        '[--tabs-padding-bottom:17px]',
      ],
      lg: [
        'text-md',
        '[--tabs-padding-y:var(--space-2)]',
        '[--tabs-padding-bottom:19.5px]',
      ],
    },
  },
});

export function tabClassNames({
  classNameL0,
  classNameL1,
  classNameL2,
  fixed,
}: {
  classNameL0?: string;
  classNameL1?: string;
  classNameL2?: string;
  fixed: boolean;
}) {
  const wrapperL0 = cx(
    'flex items-center justify-center whitespace-nowrap text-center',
    'font-semibold text-subtle hover:text-default',
    'relative -mb-px group',
    fixed &&
      'border-b-2 border-transparent data-[state=active]:border-state-selected',
    'data-[state=active]:text-default',
    classNameL0,
  );

  const wrapperL1 = cx(
    'py-[var(--tabs-padding-y)] px-2.5 -mx-2 mb-3',
    'group-hover:bg-[rgba(5,5,5,0.04)]',
    'group-hover:rounded-lg',
    fixed && 'w-full',
    classNameL1,
  );

  const wrapperL2 = cx(
    !fixed && [
      'border-b-2',
      'border-transparent',
      'pb-[var(--tabs-padding-bottom)]',
      'group-data-[state=active]:border-state-selected',
    ],
    classNameL2,
  );

  return {
    wrapperL0,
    wrapperL1,
    wrapperL2,
  };
}
